import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, ViewChild, effect, inject, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ClarityModule, ClrTimelineLayout, ClrTimelineStepState } from '@clr/angular';
import dayjs from 'dayjs';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom, Subject, Subscription } from 'rxjs';
import { first } from 'rxjs/operators';

import { BackendLocaleDatePipe } from 'src/app/pipes/get-locale-date.pipe';
import { HideIDColumnsPipe } from 'src/app/pipes/hide-idcolumns.pipe';
import { LeftPadPipe } from 'src/app/pipes/left-pad.pipe';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { TablePrettyPrintPipe } from 'src/app/pipes/tablePrettyPrint.pipe';
import { APIService } from 'src/app/services/APIService/api.service';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { OverlayService } from 'src/app/services/Overlay/overlay.service';
import { SpinnerService } from 'src/app/services/Spinner/spinner.service';
import { MangelMediaApiFuncService } from 'src/app/services/MediaApiFunc/mangel-media-api-func.service';
import { MediaViewModalComponent, TitleAndFileNames } from '../../_shared/mediaviewmodal/mediaviewmodal.component';
import { previewMap } from '../../detailview/previewMap';
import { KostenerfassungComponent } from './kostenerfassung/kostenerfassung.component';
import { MultirueckmeldungdialogComponent } from '../multirueckmeldungdialog/multirueckmeldungdialog.component';
import { DynamicStyleDirective } from 'src/app/directives/dynamic-style.directive';
import { ConfirmService } from 'src/app/services/confirm.service';
import { errorHandle, getTokenRight } from 'src/app/misc/functions';
import { ObjTypePipe } from 'src/app/pipes/objtype.pipe';
import { AuftragMangelStore } from './auftrag-mangel.store';
import { Row } from 'src/app/models/ui/table';
import { GeometryCollection } from 'geojson';
import { GetByCallbackPipe } from 'src/app/pipes/get-by-callback.pipe';
import { AbnahmeOverlayInput } from '../abnahme-protokoll/abnahme-protokoll.types';

@Component({
  selector: 'app-auftrag-detail',
  templateUrl: './auftrag-detail.component.html',
  styleUrls: ['./auftrag-detail.component.scss'],
  imports: [
    CommonModule,
    ClarityModule,
    FormsModule,
    ReactiveFormsModule,
    KostenerfassungComponent,
    MultirueckmeldungdialogComponent,
    MediaViewModalComponent,
    DynamicStyleDirective,
    HideIDColumnsPipe,
    TablePrettyPrintPipe,
    BackendLocaleDatePipe,
    MrTranslatePipe,
    LeftPadPipe,
    ObjTypePipe,
    GetByCallbackPipe,
  ],
})
export class AuftragDetailComponent {
  private readonly apiService = inject(APIService);
  private readonly changeDet = inject(ChangeDetectorRef);
  private readonly toastr = inject(ToastrService);
  private readonly mrTranslate = inject(MrTranslatePipe);
  private readonly spinner = inject(SpinnerService);
  private readonly authService = inject(AuthService);
  private readonly overlayService = inject(OverlayService);
  protected readonly localeDate = inject(BackendLocaleDatePipe);
  protected readonly media = inject(MangelMediaApiFuncService);
  private readonly confirmService = inject(ConfirmService);
  private readonly mangelStore = inject(AuftragMangelStore);

  public readonly closedialog = new Subject<boolean>();
  kostenChanged = false;
  auftragId: number;
  auftrag: any;
  firmen = [];
  firmenId: number;
  map: any;
  showGIS: boolean = false;
  timelineLayout: ClrTimelineLayout = ClrTimelineLayout.HORIZONTAL;
  wfLine: WFStep[] = [];
  wfStepCont: boolean = false;
  showrueckfrage: boolean = false;
  rueckfrage: string = '';
  rights: any;
  allowEdit: boolean;

  titel: Array<any>;
  auftragsarten: Array<any>;
  kostenart: Array<any>;
  result: Array<any>;
  auftragsgroups: Array<any>;


  auftragFormGroup = new UntypedFormGroup({
    titel: new UntypedFormControl('', [Validators.required]),
    firma: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
    termin: new UntypedFormControl(''),
    terminEnde: new UntypedFormControl(''),
    auftragsart: new UntypedFormControl(''),
    auftragsnummer: new UntypedFormControl(''),
    kostenart: new UntypedFormControl(''),
    bemerkung: new UntypedFormControl(''),
    gruppenid: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
    stoerbeginn: new UntypedFormControl(''),
    stoerbeginnzeit: new UntypedFormControl(''),
    stoerende: new UntypedFormControl(''),
    stoerendezeit: new UntypedFormControl(''),
    stoergrund: new UntypedFormControl(''),
    stoerursache: new UntypedFormControl(''),
    stoererfasser: new UntypedFormControl(''),
  });


  altMangelGroup = new UntypedFormGroup({
    omazsid: new UntypedFormControl(''),
    altvon: new UntypedFormControl(''),
    altbis: new UntypedFormControl(''),
    altinstandsetzungshinweis: new UntypedFormControl(''),
    altumfang: new UntypedFormControl(''),
    altmengeneinheit: new UntypedFormControl(''),
  });

  showaltInstandsetzung: boolean = false;
  tupleih: any = [];
  listih: any = [];
  selMangelRow: any;
  meh: any = [];
  typ_Line_Point: number;

  objTable = {
    rows: null as Row[],
    columns: [],
  };

  mangelTable = {
    rows: null as Row[],
    columns: [],
  };


  abnahmeTable = {
    rows: null as Row[],
    columns: [],
  };

  activeTab: any = {
    auftrag: true,
    rueckmeldung: false,
    abnahme: false,
    kosten: false,
  };

  mangelMedia: TitleAndFileNames[];
  showRueckTab = true;

  private dataRefresh: Subject<void>;
  refreshSubscription: Subscription;
  private readonly refreshAbnahmen = new Subject<boolean>();
  tabRefresh: EventEmitter<void> = new EventEmitter();
  optInterface: number = -1;
  inforClosed: boolean = false;
  inforJOBNUM: any = [];
  inforACTIVITYCODE: any = [];
  inforURL: any;

  isStoerung: boolean = false;
  stoerursache: any = [];
  stoergrund: any = [];
  stoererfasser: any = [];
  isWorkflow: boolean = false;
  isGenehmiger: boolean = false;
  isRueckmelder: boolean = false;

  set data({ data: { id, auftrag, maengel, objekte }, recalledData: vorData, dataRefresh }: any) {
    this.optInterface = parseInt(this.authService.decrypt(localStorage.getItem('optInterface')));

    if (id) {
      if (this.optInterface == 3) {
        this.apiService
          .getAuftragInforStoerungInhalt()
          .pipe(first())
          .subscribe(val => {
            this.stoerursache = val.stoerursache;
            this.stoergrund = val.stoergrund;
            this.stoererfasser = val.stoererfasser;
          });

        this.auftragFormGroup.get('auftragsart').addValidators([Validators.required, Validators.minLength(1)]);
        this.auftragFormGroup.get('auftragsart').updateValueAndValidity({ emitEvent: false });
        this.auftragFormGroup.get('kostenart').addValidators([Validators.required, Validators.minLength(1)]);
        this.auftragFormGroup.get('kostenart').updateValueAndValidity({ emitEvent: false });
      }

      this.auftragId = id;
      this.loadListen();
      this.loadFirmen();
    }

    this.rights = JSON.parse(this.authService.decrypt(localStorage.getItem('rights')));
    this.allowEdit = getTokenRight(this.rights.program, 'AllowPAuftrEdit');
    if (auftrag) {
      this.auftrag = auftrag;
      if (!vorData) this.setAuftrag(auftrag);

      if (auftrag.inforClosed != null) {
        this.inforClosed = auftrag.inforClosed;
      }
      if (auftrag.inforJOBNUM != null) {
        this.inforJOBNUM = auftrag.inforJOBNUM.split('|');
      }
      if (auftrag.inforACTIVITYCODE != null) {
        this.inforACTIVITYCODE = auftrag.inforACTIVITYCODE.split('|');
      }

      this.apiService
        .getINIOptions()
        .pipe()
        .subscribe(x => {
          this.isWorkflow = auftrag.wfStatus != 0 && x?.rows[0]?.optAuftrWF == 1;
          if (this.isWorkflow) this.setWFLine(auftrag.wfStatus);
        });
    }

    if (maengel?.rows?.length) {
      if (this.mangelTable.columns?.length == 0) {
        this.mangelTable.columns = maengel.columns;
      }
      this.mangelTable.rows = maengel.rows;
    }

    if (objekte?.rows?.length) {
      if (!this.objTable.columns?.length) this.objTable.columns = objekte.columns;
      this.objTable.rows = objekte.rows;
    }

    if (vorData) {
      this.auftragFormGroup.setValue(vorData.auftragForm);
      this.activeTab = vorData.activeTab;
      this.auftrag.Auftragsstatus ||= vorData.status;
    }

    if (!vorData || vorData.refreshAbnahmen.value) this.loadAbnahmen();
    else this.abnahmeTable = vorData.abnahmeTable;

    if (auftrag?.Auftragsstatus == 1 && !vorData?.preview?.length) {
      this.showRueckTab = false;
    }

    this.dataRefresh = dataRefresh;

    if (this.optInterface == 3 && auftrag.Auftragsart == 'BR  = korrektiv') {
      this.isStoerung = true;
    }
    if (this.optInterface == 3) {
      this.auftragFormGroup.controls['auftragsart'].disable();
    }
  }

  async addMangel(row: Row) {
    this.mangelStore.openedMangelErfassung(row.kauftsid as number);

    this.overlayService.setOverlay({
      overlay: 'mangelerfassung',
      isTopOverlay: true,
      id: {
        ostammid: row.ostammid,
        typ_Line_Point: row.typ_id,
        otypid: row.otypid,
        startmeter: row.StartMeter,
        endmeter: row.EndMeter,
      },
    });
  }

  editMangel() {
    let data = this.altMangelGroup.value;

    this.apiService
      .setAlternativeInstandsetzung(data)
      .pipe(first())
      .subscribe(val => {
        if (val.success) {
          this.toastr.success(this.mrTranslate.transform('Eintrag erfolgreich gespeichert'));
          this.selMangelRow.altinstandsetzungshinweis = data.altinstandsetzungshinweis;
          this.selMangelRow.altumfang = data.altumfang;
          this.selMangelRow.altmengeneinheit = data.altmengeneinheit;
        }
        this.showaltInstandsetzung = false;
      });
  }

  async onEdit(row) {
    this.selMangelRow = row;

    const item = this.objTable.rows?.find(r => r.ostammid === row.ostammid);
    if (item) {
      this.typ_Line_Point = +item.typ_id;
    }

    if (this.tupleih.length == 0) {
      let val = await firstValueFrom(this.apiService.getListAltInstandsetzung(row.ostammid));
      this.tupleih = val['listih'];
      this.meh = val['meh'];
    }

    this.listih = this.tupleih.filter(d => d.Item1 === row.Prüfart);
    this.altMangelGroup.controls.omazsid.setValue(row.OMAZSID);
    this.altMangelGroup.controls.altinstandsetzungshinweis.setValue(row.altinstandsetzungshinweis);
    this.altMangelGroup.controls.altumfang.setValue(row.altumfang);
    this.altMangelGroup.controls.altmengeneinheit.setValue(row.altmengeneinheit);

    if (row.altmengeneinheit == null && row.mengeneinheit != '') {
      this.altMangelGroup.controls.altmengeneinheit.setValue(row.mengeneinheit);
    }

    if (row.altumfang == null && row.umfang != '') {
      this.altMangelGroup.controls.altumfang.setValue(row.umfang);
    }

    this.showaltInstandsetzung = true;
  }

  private setWFLine(wfStatus) {
    this.wfLine = [];
    this.apiService
      .AuftragWFStatus({
        mode: 'GET',
        kauftrID: this.auftragId,
        titles: ['Beantragt', 'Genehmigt', 'In Arbeit', 'Rückgemeldet', 'Erledigt'],
      })
      .pipe(first())
      .subscribe((val: any) => {
        if (val.steps) {
          val.steps.forEach(row => {
            var i = row.status;
            this.wfLine.push({
              status:
                wfStatus == 5 ? ClrTimelineStepState.SUCCESS
                : i == -wfStatus ? ClrTimelineStepState.ERROR
                : i == wfStatus ? ClrTimelineStepState.CURRENT
                : i < Math.abs(wfStatus) ? ClrTimelineStepState.SUCCESS
                : ClrTimelineStepState.NOT_STARTED,
              time: row.time,
              title: row.title,
              description: row.description,
            });
          });
        }
        if (val.rol) {
          this.isGenehmiger = val.rol.AllowPAuftrGen ?? false;
          this.isRueckmelder = val.rol.AllowPAuftrRueck ?? false;
        }
      });
  }

  set dateforall(newdate: Date) {
    for (let i = 0; i < this.mangelTable.rows.length; i++) {
      this.mangelTable.rows[i].termin = newdate;
    }
  }

  trial = false;

  constructor() {
    this.trial = this.authService.getToken().trial;
    this.mangelStore.openedMangelErfassung(null);
    effect(() => {
      const reloaded = this.mangelStore.maengel();
      if (reloaded.length) {
        this.mangelTable.rows = reloaded;
        this.mangelStore.saveReloadedMangel([]);
      }
    });
  }

  openEAMAuftrag(v) {
    let url = this.inforURL.replace('{0}', v);
    window.open(url, '_blank');
  }

  async closeEAMAuftrag() {
    const text = this.mrTranslate.transform('Auftrag wirklich abschließen');
    const ok = await this.confirmService.warning(text);
    if (ok) {
      let send = {
        inforjobnum: this.inforJOBNUM,
        auftragid: this.auftragId,
      };

      this.apiService
        .setCloseEAMAuftrag(send)
        .pipe(first())
        .subscribe((res: any) => {
          if (res?.success) {
            const message = this.mrTranslate.transform('Auftrag wurde erfolgreich abgeschlossen');
            this.toastr.success(message);
            this.inforClosed = true;
            this.dataRefresh?.next();
          } else {
            const message = this.mrTranslate.transform('Fehler beim Speichern');
            this.toastr.error(res?.error || null, message);
          }
        });
    }
  }

  private async loadListen() {
    ({
      kostenart: this.kostenart,
      auftragart: this.auftragsarten,
      titel: this.titel,
    } = await firstValueFrom(this.apiService.getNeuAuftraegWerte()));

    if (this.optInterface == 3) {
      this.auftragsarten = ['BR  = korrektiv', 'MPM = präventiv'];
    }

    this.auftragsgroups = await firstValueFrom(this.apiService.getAuftragsGroups());

    if (this.optInterface == 3) {
      const { success, url } = await firstValueFrom(this.apiService.getAuftragInforUrl());
      if (success) this.inforURL = url;
    }
  }

  private async loadFirmen() {
    const firmen = await firstValueFrom(this.apiService.getFirmen());
    this.firmen = firmen.rows;
    this.firmenId = this.firmen.find(firma => firma.Firma == this.auftrag.Firma)?.ID;
  }

  protected async deleteMangelAuftrag(row: Row) {
    // if (this.mangelTablrueck.rows.length === 1) {
    //   this.toastr.warning(
    //     this.mrTranslate.transform('Löschen ist nicht möglich, es muss mindestes 1 Mangel im Auftrag enthalten sein.')
    //   );
    //   return;
    // }

    const text = this.mrTranslate.transform('Sind sie sicher, dass sie den Mangel aus dem Auftrag löschen möchten');
    const ok = await this.confirmService.danger(text);
    if (!ok) return;

    try {
      const objektRemoved = await this.apiService.deleteMangelAusAuftrag(+row.omazsid);
      if (objektRemoved) {
        this.objTable.rows = this.objTable.rows.filter(obj => obj.ostammid != row.ostammid);
      }
      this.mangelTable.rows = this.mangelTable.rows.filter(m => m !== row);
      //this.mangelTablrueck.rows = this.mangelTable.rows;

      this.toastr.success(this.mrTranslate.transform('Mangel aus Auftrag gelöscht'));
      this.dataRefresh?.next();
    } catch (er) {
      this.toastr.error(errorHandle(er));
    }
  }

  private async loadAbnahmen() {
    const abnahmen = await firstValueFrom(this.apiService.getAbnahmen(this.auftragId));
    if (abnahmen?.rows?.length) {
      if (!this.abnahmeTable.columns?.length) this.abnahmeTable.columns = abnahmen.columns;
      this.abnahmeTable.rows = abnahmen.rows;
    }
    this.resizeGrids();
  }

  setAuftrag(auftrag: any) {
    this.auftragFormGroup.controls.titel.setValue(auftrag.Titel || '');
    this.auftragFormGroup.controls.firma.setValue(auftrag.Firma || '');
    this.auftragFormGroup.controls.termin.setValue(auftrag['Termin Anfang'] || '');
    this.auftragFormGroup.controls.terminEnde.setValue(auftrag['Termin Ende'] || '');
    this.auftragFormGroup.controls.auftragsart.setValue(auftrag.Auftragsart || '');
    this.auftragFormGroup.controls.auftragsnummer.setValue(auftrag.Auftragsnummer || '');
    this.auftragFormGroup.controls.kostenart.setValue(auftrag.Kostenart || '');
    this.auftragFormGroup.controls.bemerkung.setValue(auftrag.Bemerkung || '');
    this.auftragFormGroup.controls.gruppenid.setValue(auftrag.Gruppe || '');

    this.auftragFormGroup.controls.stoerursache.setValue(auftrag.Ursache || '');
    this.auftragFormGroup.controls.stoergrund.setValue(auftrag.Störgrund || '');
    this.auftragFormGroup.controls.stoererfasser.setValue(auftrag.Festgestellt || '');

    if (auftrag.Störbeginn != null && auftrag.Störbeginn != '1900-01-01T00:00:00') {
      var myTime = auftrag.Störbeginn.substr(11, 5);
      this.auftragFormGroup.controls.stoerbeginn.setValue(auftrag.Störbeginn || '');
      this.auftragFormGroup.controls.stoerbeginnzeit.setValue(myTime || '');
    }
    if (auftrag.Störende != null && auftrag.Störende != '1900-01-01T00:00:00') {
      var myTime = auftrag.Störende.substr(11, 5);
      this.auftragFormGroup.controls.stoerende.setValue(auftrag.Störende || '');
      this.auftragFormGroup.controls.stoerendezeit.setValue(myTime || '');
    }
  }

  getAuftragsgruppeName(id: number) {
    let gruppe;
    if (this.auftragsgroups) gruppe = this.auftragsgroups.filter(item => item.id == id)[0]?.Bezeichnung;
    return gruppe || undefined;
  }

  protected async saveAuftrag() {
    this.auftragFormGroup.markAsTouched();
    if (!this.auftragFormGroup.valid) {
      return;
    }

    const formValue = this.auftragFormGroup.value;

    if (dayjs(formValue.terminEnde).isBefore(formValue.termin, 'days'))
      return this.toastr.warning(this.mrTranslate.transform('Das Startdatum muss vor dem Enddatum liegen.'));

    if (!formValue.titel) {
      return this.toastr.warning(this.mrTranslate.transform('Bitte geben Sie eine Titel an.'));
    }

    let send = {
      items: formValue,
      optInterface: this.optInterface.toString(),
      inforjobnum: this.inforJOBNUM,
      inforactivitycode: this.inforACTIVITYCODE,
    };
    try {
      const res = await firstValueFrom(this.apiService.updateAuftrag(this.auftragId, send));
      if (!res?.success) throw new Error(res?.error);

      await this.updateAuftragInMaengel();
      this.toastr.success(this.mrTranslate.transform('Auftrag gespeichert'));
      this.dataRefresh?.next();
    } catch (er) {
      this.toastr.error(errorHandle(er), this.mrTranslate.transform('Fehler beim Speichern'));
    }
  }

  private updateAuftragInMaengel() {
    return Promise.all(
      this.mangelTable.rows.map(row => this.apiService.updateMangelAuftrag(+row.omazsid, this.auftragId))
    );
  }

  openAbnahmeProtokoll(row: any = undefined) {
    const abnahmeOverlay: AbnahmeOverlayInput = {
      data: {
        abnahmeId: row?.abnahmeId,
        id: this.auftragId,
        titel: this.auftragFormGroup.value.titel,
        auftragnehmer: this.auftragFormGroup.value.firma,
        objTable: this.objTable,
        firmenId: this.firmenId,
      },
      dataRefresh: this.dataRefresh,
      refreshAbnahmen: this.refreshAbnahmen,
    };

    this.overlayService.setOverlay({
      overlay: 'abnahmeProtokoll',
      zIndex: 8,
      ...abnahmeOverlay,
      recallData: {
        auftragForm: this.auftragFormGroup.getRawValue(),
        activeTab: this.activeTab,
        status: this.auftrag.Auftragsstatus,
        refreshAbnahmen: this.refreshAbnahmen,
        abnahmeTable: this.abnahmeTable,
      },
    });
  }
 
  public setWFAuftragStatus(type: number) {
    const titles = ['Beantragt', 'Genehmigt', 'In Arbeit', 'Rückgemeldet', 'Erledigt'];
    var wfStatus = this.auftrag.wfStatus;
    wfStatus =
      type == 1 ? wfStatus + 1
      : type == 3 ? 3
      : -wfStatus;
    this.showrueckfrage = false;

    this.apiService
      .AuftragWFStatus({
        mode: 'INSERT',
        status: type,
        wfstep: wfStatus,
        kauftrID: this.auftragId,
        titles: titles,
        comment: this.rueckfrage,
      })
      .pipe(first())
      .subscribe(() => {
        this.setWFLine(wfStatus);
        this.wfStepCont = true;
        this.dataRefresh?.next();
      });
  }

  public close() {
    if (this.kostenChanged) this.dataRefresh?.next();
    setTimeout(() => {
      this.closedialog.next(true);
    });
  }

  protected previewMap(mangel: Row, objekt: Row) {
    this.showGIS = true;
    mangel.baseVon = objekt?.StartMeter || 0;
    setTimeout(() => {
      this.map = previewMap(mangel, objekt?.geometry, this.map);
    });
  }

  protected getObjektByMangel = (row: Row) => this.objTable.rows?.find(el => el.ostammid == row.ostammid);

  protected getGeometryType = (row: Row) => (row?.geometry as GeometryCollection)?.type;

  resizeGrids() {
    this.changeDet.detectChanges();
  }

  setAllFirmen(event: any) {
    for (let i = 0; i < this.mangelTable.rows.length; i++) {
      this.mangelTable.rows[i].auftragnehmer = event.target.value;
    }
  }

  tabChange() {
    this.tabRefresh.emit();
  }

  async deleteAuftrag() {
    const text = this.mrTranslate.transform('Auftrag wirklich löschen?');
    const ok = await this.confirmService.danger(text);
    if (ok) {
      this.spinner.enable();
      this.apiService
        .deleteAuftrag(this.auftragId)
        .pipe(first())
        .subscribe((res: unknown) => {
          if (res['status'] === 'success') {
            const message = this.mrTranslate.transform('Auftrag gelöscht');
            this.toastr.success(message);
            this.close();
            this.dataRefresh?.next();
          } else {
            const message = this.mrTranslate.transform('Fehler beim Löschen');
            this.toastr.error(res['error'] || null, message);
          }
        });
    }
  }

}

export interface UpdateAuftrag {
  titel: string;
  firma: string;
  termin: string;
  terminEnde: string;
  auftragsart: string;
  auftragsnummer: string;
  kostenart: string;
  bemerkung: string;
}

interface WFStep {
  time: string;
  status: ClrTimelineStepState;
  title: string;
  description?: string;
}